import { useMemo } from 'react'
import Link from 'next/link'

export const GlobalLink = ({ link, children, className = '' }) => {
  const href = useMemo(() => {
    if (link.type === 'external') return link.url
    if (!link.to) return ''
    switch (link.to._type) {
      case 'page':
        return `/${link.to.slug.current}`
      case 'collection':
        return `/collections/${link.to.store.slug.current}`
      case 'product':
        return `/products/${link.to.store.slug.current}`
      default:
        return ''
    }
  }, [link])

  if (link.type === 'external') {
    return (
      <Link
        scroll={false}
        href={href}
        className={className}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </Link>
    )
  }

  return (
    <Link scroll={false} href={href} className={className}>
      {children}
    </Link>
  )
}
